export function arrayDataChecker(data: any[]): {
  isObjectArray: boolean
} {
  return {
    isObjectArray: data.every(item => typeof item === 'object')
  }
}